import PersistenceService from "@/services/PersistenceService";
import axios from "axios";
import { useUserStore } from "@/store/modules/user";

const userIsLoggedIn = () =>
  PersistenceService.getFromLocalStorage("userAccessToken");

export default {
  async checkAuthentication(to, from, next) {
    const token = userIsLoggedIn();

    if (!token) {
      return next("/login");
    }

    const userStore = useUserStore();
    const apiUrl = process.env.VUE_APP_API_URL;

    try {
      const response = await axios.get(`${apiUrl}/api/v1/info`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response.status !== 200 || response.data?.success !== true) {
        throw new Error("Session validation failed");
      }

      userStore.update(response.data.user);

      const allowedRoles = to.matched.flatMap((route) => route.meta.roles || []);
      if (
        allowedRoles.length > 0 &&
        !allowedRoles.includes(Number(response.data.user?.role_id))
      ) {
        return next("/");
      }

      return next();
    } catch {
      userStore.logout();
      return next("/login");
    }
  },
};
